import {createFileRoute, notFound} from '@tanstack/react-router';
import {HomeLayout} from '@features/flow/components/HomeLayout';
import {TUTORIALS} from '@features/chat/components/TutorialCard';
import {TutorialDetailView} from '@features/flow/components/TutorialDetailView';
import {z} from 'zod';

export const Route = createFileRoute('/tutorials/$id')({
  component: TutorialDetailPage,
  validateSearch(search) {
    return z
      .object({
        from: z.string().optional(),
      })
      .parse(search);
  },
});

function TutorialDetailPage() {
  const {id} = Route.useParams();
  const tutorial = TUTORIALS.find((t) => t.id === id);

  // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack notFound() is not an Error
  if (!tutorial) throw notFound();

  return (
    <HomeLayout currentView='tutorials' hideHeader>
      <title>Banani | Tutorials</title>
      <TutorialDetailView tutorial={tutorial} />
    </HomeLayout>
  );
}
